// extracted by mini-css-extract-plugin
export var wrapper = "Accordion-module--wrapper--dda65";
export var faq = "Accordion-module--faq--3c897";
export var panel = "Accordion-module--panel--497d3";
export var title = "Accordion-module--title--71eeb";
export var panelContentWrapper = "Accordion-module--panelContentWrapper--4bee0";
export var active = "Accordion-module--active--e32ea";
export var collapse = "Accordion-module--collapse--318ed";